// import { apiClient } from "../../../client";

// export interface PaginatedResponse<T> {
//     data: T[]
//     total: number
//     page: number
//     limit: number
//     totalPages: number
// }

// export interface KPIVisitFilters {
//     search?: string;
//     client_ids?: string;
//     region_ids?: string;
//     city_ids?: string;
//     channel_ids?: string;
//     chain_ids?: string;
//     store_format_ids?: string;
//     store_class_ids?: string;
//     store_ids?: string;
//     user_ids?: string;
//     report_to_ids?: string;
//     category_ids?: string;
//     subcategory_ids?: string;
//     start_date?: string;
//     end_date?: string;
//     /** Visit status: 0 = pending, 1 = in progress, 2 = completed */
//     status?: string;
//     shift_ids?: string;
//     is_planned?: string;
//     ref_ids?: string
// }

// /** Visit row for map: store + today's visits for current user */
// export interface MapVisit {
//     id: number;
//     user_id: number;
//     user_name: string;
//     store_id: number;
//     store_name: string;
//     g_code: string | null;
//     checkin_gps: string | null;
//     shift_id: number;
//     shift_name: string;
//     status: number;
//     from_date: string;
//     to_date: string;
//     client_id: number;
//     checkin_time: string | null;
//     checkin_image: string | null;
//     checkout_time: string | null;
//     checkout_image: string | null;
//     dynamic_bucket_url: string;
//     visit_type_name: string;
// }

// export interface TrackingLocationPoint {
//     seq: number;
//     time: string;
//     store_id: number | null;
//     store_name: string | null;
//     lat: number;
//     lng: number;
//     distance_meters?: number | null;
//     work_status?: string;
//     indication?: string;
// }

// export interface TrackingUserRow {
//     user_id: number;
//     user_name: string;
//     email: string | null;
//     phone: string | null;
//     region_name: string | null;
//     city_name: string | null;
//     location: string | null;
//     lat: number | null;
//     lng: number | null;
//     last_track_at: string;
//     last_seen: string;
//     minutes_since_last_track: number;
//     total_points: number;
//     status: 'active' | 'idle' | 'offline';
//     locations: TrackingLocationPoint[];
// }

// export interface TrackingOverviewFilters {
//     date?: string;
//     start_date?: string;
//     region_ids?: string;
//     city_ids?: string;
//     user_ids?: string;
//     report_to_ids?: string;
// }

// export type TrackingStatusMapStatus = 'In Store' | 'Idle / On Route' | 'Need Attention' | 'OK';

// export interface TrackingStatusMapRow {
//     user_id: number;
//     user_name: string;
//     username: string | null;
//     region_id: number | null;
//     region: string | null;
//     city_id: number | null;
//     city: string | null;
//     store_id: number;
//     store_name: string | null;
//     location: string | null;
//     lat: number | null;
//     lng: number | null;
//     last_tracking_time: string;
//     distance_meters: number | null;
//     status: TrackingStatusMapStatus;
//     last_seen: string;
//     work_status?: string;
//     indication?: string;
// }

// export interface TrackingStatusMapResponse {
//     summary: {
//         total: number;
//         in_store: number;
//         idle_on_route: number;
//         need_attention: number;
//         ok: number;
//     };
//     users: TrackingStatusMapRow[];
// }

// export interface TrackingOverviewResponse {
//     summary: {
//         total: number;
//         active: number;
//         idle: number;
//         offline: number;
//     };
//     users: TrackingUserRow[];
// }

// export interface TrackingVisitPin {
//     id: number;
//     sequence: number;
//     tracking_time: string;
//     tracked_at: string;
//     location: string | null;
//     lat: number;
//     lng: number;
//     store_id: number | null;
//     store_name: string | null;
//     distance_meters?: number | null;
//     work_status?: string;
//     indication?: string;
// }

// export interface UserTrackingVisitsResponse {
//     user_id: number;
//     user_name: string;
//     date: string;
//     visits: TrackingVisitPin[];
// }

// /** Date fields are sent as ISO 8601 strings (e.g. "2026-02-16T06:30:00Z") for correct backend parsing. */
// export interface CreateKPIVisitRequest {

//     project_code?: string;
//     user_id: number;
//     client_id: number;
//     store_id: number;
//     shift_id: number;
//     is_planned: number;
//     visit_type_id: number;
//     status: number;
//     from_date: string | Date;
//     to_date: string | Date;
//     category_ids?: number[];
//     subcategory_ids?: number[];
//     overtime_unplanned_visit?: number;
// }

// export interface UpdateKPIVisitRequest {
//     id: number;
//     project_code?: string;
//     user_id: number;
//     client_id: number;
//     store_id: number;
//     shift_id: number;
//     is_planned: number;
//     visit_type_id: number;
//     status: number;
//     from_date: string | Date;
//     to_date: string | Date;
//     category_ids?: number[];
//     subcategory_ids?: number[];
//     overtime_unplanned_visit?: number;
// }


// export interface KPIVisit {
//     id: number;
//     client_id: number;
//     dynamic_bucket_url: string;
//     tenant_id: number;
//     client_name: string;
//     project_code: string;
//     user_id: number;
//     user_name: string;
//     user_display_name: string;
//     store_id: number;
//     store_name: string;
//     depo?: string | null;
//     shift_id: number;
//     shift_name: string;
//     is_planned: number;
//     visit_type_id: number;
//     status: number;
//     from_date: Date;
//     to_date: Date;
//     report_to: number;
//     report_to_name: string;
//     region_name: string;
//     city_name: string;
//     channel_name?: string | null;
//     chain_name?: string | null;
//     store_format_name?: string | null;
//     store_class_name?: string | null;
//     visit_type_name: string;
//     checkin_time: string;
//     checkout_time: string;
//     checkin_image: string;
//     checkout_image: string;
//     working_hours?: number;
//     checkout_comment?: string;
//     checkin_comment?: string;
//     checkin_gps?: string;
//     checkout_gps?: string;
//     category_ids?: string | null;
//     subcategory_ids?: string | null;
//     category_names?: string[];
//     subcategory_names?: string[];
//     store_code?: string;
//     g_code?: string | null;
//     ref_id_1?: string
//     overtime_unplanned_visit?: number;
//     reason_text?: string;
//     assign_by?: string;
// }

// /** Attendance sheet row: each date maps to a single P/L/A string */
// export interface AttendanceSheetRow {
//     city_name: string;
//     region_name: string;
//     user_name: string;
//     report_to_name: string;
//     slots: Record<string, string>;
// }

// export interface AttendanceSheetByValueRow {
//     id: number;
//     city_name: string;
//     region_name: string;
//     user_name: string;
//     userName: string;
//     report_to_name: string;
//     attendance_days: Record<string, string>;
// }

// export interface PerformanceOverviewAttendanceBreakdownItem {
//     attendance: string;
//     users: number;
// }

// export interface PerformanceOverviewAttendance {
//     total: number;
//     present: { count: number; percentage: number };
//     absent: { count: number; percentage: number };
// }

// export interface PerformanceOverviewRegionRow {
//     region: string;
//     total: number;
//     present: number;
//     absent: number;
//     jpc: number;
//     productivityPct: number;
// }

// export interface PerformanceOverviewCityRow {
//     city: string;
//     total: number;
//     present: number;
//     absent: number;
//     jpc: number;
//     productivityPct: number;
// }

// export interface PerformanceOverviewReportToRow {
//     region: string;
//     city: string;
//     reportTo: string;
//     total: number;
//     present: number;
//     absent: number;
//     jpc: number;
//     productivityPct: number;
// }

// export interface PerformanceOverviewTrendPoint {
//     label: string;
//     value: number;
// }

// export interface PerformanceOverviewResponse {
//     reportDate?: string;
//     data: {
//         attendanceBreakdown: PerformanceOverviewAttendanceBreakdownItem[];
//         attendance: PerformanceOverviewAttendance;
//         jpc: {
//             planned: number;
//             unplanned: number;
//             completed: number;
//             value: number;
//             unplannedCompleted: number,
//         };
//         productivity: {
//             planned: number;
//             unplanned: number;
//             completed: number;
//             percentage: number;
//         };
//         summary: {
//             totalUsers: number;
//             plannedVisits: number;
//             unplannedVisits: number;
//             totalCompleted: number;
//         };
//     };
//     byRegion?: PerformanceOverviewRegionRow[];
//     byCity?: PerformanceOverviewCityRow[];
//     byReportTo?: PerformanceOverviewReportToRow[];
//     visitCheckinTrend?: PerformanceOverviewTrendPoint[];
//     dayStartTrend?: PerformanceOverviewTrendPoint[];
//     scorecardMetrics?: PerformanceOverviewScorecardMetrics;
//     visitFunnel?: VisitOverviewSummary;
// }

// export interface PerformanceOverviewScorecardMetrics {

//     totalWorkingMinutes: number;
//     workingMinutesTarget: number;
//     workingMinutesPct: number;
//     totalTravelMinutes: number;
//     avgWorkingMinutesPerUser: number;

//     avgTravelMinutesPerUser: number;
//     travelMinutesTarget: number;
//     travelMinutesPct: number;
//     totalTravelTime: number;

//     avgStoreVisits: number;
//     totalInStoreTime: number;
//     inStoreTimePct: number;
// }

// export interface ScoreCardRow {
//     date: string;
//     region: string;
//     city: string;
//     user: string;
//     reportTo: string;
//     attendance: string;
//     assigned: number;
//     un_assigned: number;
//     completed: number;
//     productivity: number;
//     efficiency: number;
// }

// export interface ScoreCardSummary {
//     totalRows: number;
//     /** Any check-in (OT + L) */
//     present: number;
//     onTime: number;
//     late: number;
//     absent: number;
//     totalAssigned: number;
//     totalCompleted: number;
//     productivity: number;
//     efficiency: number;
// }

// export interface ScoreCardResponse {
//     data: ScoreCardRow[];
//     total: number;
//     page: number;
//     limit: number;
//     totalPages: number;
//     summary: ScoreCardSummary;
// }

// export interface VisitOverviewSummary {
//     total: number;
//     pending: number;
//     inprogress: number;
//     completed: number;
//     other: number;
// }

// export interface VisitOverviewFilters {
//     start_date?: string;
//     end_date?: string;
//     region_ids?: string;
//     city_ids?: string;
//     user_ids?: string;
//     report_to_ids?: string;
// }

// export interface VisitOverviewRegionStatus {
//     region: string;
//     pending: number;
//     inprogress: number;
//     completed: number;
//     other: number;
//     total: number;
// }

// export interface VisitOverviewCityStatus {
//     city: string;
//     pending: number;
//     inprogress: number;
//     completed: number;
//     other: number;
//     total: number;
// }

// export interface VisitOverviewRegionHeatmap {
//     region: string;
//     pending: number;
//     inprogress: number;
//     completed: number;
//     other: number;
//     total: number;
//     completion_rate: number;
//     center_lat: number | null;
//     center_lng: number | null;
// }

// export interface VisitOverviewLocationBreakdownRow {
//     region: string;
//     city: string;
//     reportTo: string;
//     /** Report-to user type (e.g. SV, EL) for supervisor breakdown. */
//     svBreakdown: string;
//     pending: number;
//     inprogress: number;
//     completed: number;
//     other: number;
//     total: number;
//     completionRate: number;
//     /** Planned completed / planned visits (same definition as performance overview JPC). */
//     jpc: number;
//     productivityPct: number;
// }

// export interface VisitOverviewDetailsResponse {
//     regionHeatmap: VisitOverviewRegionHeatmap[];
//     statusByRegion: VisitOverviewRegionStatus[];
//     statusByCity: VisitOverviewCityStatus[];
//     locationBreakdown: VisitOverviewLocationBreakdownRow[];
// }

// export interface AttendanceOverviewAttendanceBreakdownItem {
//     attendance: string;
//     users: number;
// }

// export interface AttendanceOverviewSummary {
//     total: number;
//     present: number;
//     absent: number;
//     presentPct?: number;
//     absentPct?: number;
// }

// export interface AttendanceOverviewRegionRow {
//     region: string;
//     total: number;
//     present: number;
//     absent: number;
// }

// export interface AttendanceOverviewCityRow {
//     city: string;
//     total: number;
//     present: number;
//     absent: number;
// }

// export interface AttendanceOverviewReportToRow {
//     region: string;
//     city: string;
//     reportTo: string;
//     total: number;
//     present: number;
//     absent: number;
//     jpc?: number;
//     productivityPct?: number;
// }

// export interface AttendanceOverviewResponse {
//     reportDate?: string;
//     attendanceBreakdown?: AttendanceOverviewAttendanceBreakdownItem[];
//     summary: AttendanceOverviewSummary;
//     byRegion: AttendanceOverviewRegionRow[];
//     byCity: AttendanceOverviewCityRow[];
//     byReportTo: AttendanceOverviewReportToRow[];
// }

// class KPIVisitRepository {


//     async findAll(page: number = 1, limit: number = 10, filters?: KPIVisitFilters): Promise<PaginatedResponse<KPIVisit>> {
//         const params = new URLSearchParams({
//             page: page.toString(),
//             limit: limit.toString(),
//         });

//         if (filters) {
//             for (const [key, value] of Object.entries(filters)) {
//                 if (value == null || value === '') continue;
//                 params.append(key, String(value));
//             }
//         }

//         return apiClient.get<PaginatedResponse<KPIVisit>>(`/bkpis_visit?${params.toString()}`);
//     }

//     async getAttendance(year: number, month: number): Promise<{ data: AttendanceSheetRow[] }> {
//         const params = new URLSearchParams({ year: String(year), month: String(month) });
//         return apiClient.get<{ data: AttendanceSheetRow[] }>(`/bkpis_visit/attendance?${params.toString()}`);
//     }

//     // async getAttendanceByValue(year: number, month: number): Promise<{ data: AttendanceSheetByValueRow[] }> {
//     //     const params = new URLSearchParams({ year: String(year), month: String(month) });
//     //     return apiClient.get<{ data: AttendanceSheetByValueRow[] }>(`/bkpis_visit/attendancebyValue?${params.toString()}`);
//     // }

//     async getAttendanceByValue(params: { start_date: string, end_date: string }): Promise<{ data: AttendanceSheetByValueRow[] }> {
//         const query = new URLSearchParams(params).toString()
//         return apiClient.get<{ data: AttendanceSheetByValueRow[] }>(`/bkpis_visit/attendancebyValue?${query}`);
//     }

//     async getPerformanceOverview(): Promise<PerformanceOverviewResponse> {
//         return apiClient.get<PerformanceOverviewResponse>('/performance-overview');
//     }

//     /** Get visits for map. Omit storeId to get all visits for the date (show users on map). */
//     async getVisitsForMap(storeId?: number | null, date?: string): Promise<{ data: MapVisit[] }> {
//         const params = new URLSearchParams();
//         if (storeId != null) params.set('store_id', String(storeId));
//         if (date) params.set('date', date);
//         const q = params.toString();
//         const path = q ? `/bkpis_visit/map?${q}` : '/bkpis_visit/map';
//         return apiClient.get<{ data: MapVisit[] }>(path);
//     }

//     async create(data: CreateKPIVisitRequest): Promise<KPIVisit> {
//         return apiClient.post<KPIVisit>('/bkpis_visit', data)
//     }


//     async update(id: number, data: UpdateKPIVisitRequest): Promise<KPIVisit> {
//         return apiClient.put<KPIVisit>(`/bkpis_visit/${id}`, data)
//     }

//     async delete(id: number): Promise<{ message: string }> {
//         return apiClient.delete<{ message: string }>(`/bkpis_visit/${id}`)
//     }

//     async exportTemplate(filters?: KPIVisitFilters): Promise<Blob> {
//         const params = new URLSearchParams()

//         if (filters) {
//             if (filters.search) params.append('search', filters.search);
//         }

//         const API_BASE_URL = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:5000'
//         const baseUrl = `${API_BASE_URL}/bkpis_visit/export/template`;
//         const queryString = params.toString();
//         const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;

//         return apiClient.getBlob(url, true, { showSuccessToast: true, successMessage: 'Exported Successfully' })
//     }

//     async importFromExcel(file: File): Promise<{
//         success: boolean;
//         message: string;
//         data: {
//             success: boolean;
//             total: number;
//             created: number;
//             updated: number;
//             errors: Array<{ row: number; message: string }>;
//         };
//     }> {
//         const formData = new FormData()
//         formData.append('file', file)
//         return apiClient.post('/bkpis_visit/import/excel', formData)
//     }

//     async importTable(file: File, tableName: string, sheetName?: string): Promise<{
//         success: boolean;
//         message: string;
//         data: {
//             success: boolean;
//             total: number;
//             created: number;
//             updated: number;
//             errors: Array<{ row: number; message: string }>;
//         };
//     }> {
//         const formData = new FormData()
//         formData.append('file', file)
//         formData.append('tableName', tableName)
//         if (sheetName) formData.append('sheetName', sheetName)
//         return apiClient.post('/bkpis_visit/table/import', formData)
//     }

//     async exportTableTemplate(tableName: string): Promise<Blob> {
//         return apiClient.getBlob(`/bkpis_visit/table/${tableName}/export/template`)
//     }

//     async exportAttendance(params: { year: number; month: number }): Promise<Blob> {
//         const query = new URLSearchParams({
//             year: String(params.year),
//             month: String(params.month),
//         }).toString()

//         const url = `/bkpis_visit/attendance/export?${query}`

//         const response = await apiClient.getBlob(url, true, { showSuccessToast: true, successMessage: 'Exported Successfully' })

//         return response
//     }

//     async findAllTableRecords(tableName: string): Promise<Array<{ id: number; name: string; from: string; to: string; status: number }>> {
//         return apiClient.get<{ data: Array<{ id: number; name: string; from: string; to: string; status: number }> }>(`/bkpis_visit/table/${tableName}`)
//             .then(response => response.data);
//     }

//     async exportToExcel(page: number = 1, limit: number = 25, filters?: any): Promise<Blob> {

//         const params = new URLSearchParams({
//             page: page.toString(),
//             limit: limit.toString()
//         });

//         if (filters) {
//             for (const [key, value] of Object.entries(filters)) {
//                 if (value === undefined || value === null || value === '') continue;

//                 let paramValue: string;

//                 if (typeof value === 'object') {
//                     paramValue = JSON.stringify(value); // safely handle objects/arrays
//                 } else if (
//                     typeof value === 'string' ||
//                     typeof value === 'number' ||
//                     typeof value === 'boolean'
//                 ) {
//                     paramValue = value.toString(); // handle primitives
//                 } else {
//                     continue; // skip unsupported types
//                 }

//                 params.set(key, paramValue);
//             }
//         }

//         const baseUrl = `/bkpis_visit/visit-history/export`;
//         const queryString = params.toString();
//         const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;

//         return apiClient.getBlob(url, true, { showSuccessToast: true, successMessage: 'Exported Successfully' });
//     }

//     async getScoreCard(
//         page: number = 1,
//         limit: number = 10,
//         filters?: { date?: string; start_date?: string; end_date?: string; region_ids?: string; city_ids?: string; user_ids?: string },
//     ): Promise<ScoreCardResponse> {
//         const params = new URLSearchParams({
//             page: page.toString(),
//             limit: limit.toString(),
//         });
//         if (filters?.date) params.set('date', filters.date);
//         if (filters?.start_date) params.set('start_date', filters.start_date);
//         if (filters?.end_date) params.set('end_date', filters.end_date);
//         if (filters?.region_ids) params.set('region_ids', filters.region_ids);
//         if (filters?.city_ids) params.set('city_ids', filters.city_ids);
//         if (filters?.user_ids) params.set('user_ids', filters.user_ids);

//         return apiClient.get<ScoreCardResponse>(`/bkpis_visit/score-card?${params.toString()}`);
//     }

//     async getVisitOverviewSummary(filters?: VisitOverviewFilters): Promise<VisitOverviewSummary> {
//         const params = new URLSearchParams();
//         if (filters?.start_date) params.set('start_date', filters.start_date);
//         if (filters?.end_date) params.set('end_date', filters.end_date);
//         if (filters?.region_ids) params.set('region_ids', filters.region_ids);
//         if (filters?.city_ids) params.set('city_ids', filters.city_ids);
//         if (filters?.user_ids) params.set('user_ids', filters.user_ids);
//         if (filters?.report_to_ids) params.set('report_to_ids', filters.report_to_ids);

//         const q = params.toString();
//         const path = q ? `/bkpis_visit/visit-overview/summary?${q}` : '/bkpis_visit/visit-overview/summary';
//         return apiClient.get<VisitOverviewSummary>(path);
//     }

//     async getVisitOverviewDetails(filters?: VisitOverviewFilters): Promise<VisitOverviewDetailsResponse> {
//         const params = new URLSearchParams();
//         if (filters?.start_date) params.set('start_date', filters.start_date);
//         if (filters?.end_date) params.set('end_date', filters.end_date);
//         if (filters?.region_ids) params.set('region_ids', filters.region_ids);
//         if (filters?.city_ids) params.set('city_ids', filters.city_ids);
//         if (filters?.user_ids) params.set('user_ids', filters.user_ids);
//         if (filters?.report_to_ids) params.set('report_to_ids', filters.report_to_ids);

//         const q = params.toString();
//         const path = q ? `/bkpis_visit/visit-overview/details?${q}` : '/bkpis_visit/visit-overview/details';
//         return apiClient.get<VisitOverviewDetailsResponse>(path);
//     }

//     async getAttendanceOverview(filters?: VisitOverviewFilters): Promise<AttendanceOverviewResponse> {
//         const params = new URLSearchParams();
//         if (filters?.start_date) params.set('start_date', filters.start_date);
//         if (filters?.end_date) params.set('end_date', filters.end_date);
//         if (filters?.region_ids) params.set('region_ids', filters.region_ids);
//         if (filters?.city_ids) params.set('city_ids', filters.city_ids);
//         if (filters?.user_ids) params.set('user_ids', filters.user_ids);
//         const q = params.toString();
//         const path = q ? `/attendance-overview?${q}` : '/attendance-overview';
//         return apiClient.get<AttendanceOverviewResponse>(path);
//     }

//     async getTrackingOverview(filters?: TrackingOverviewFilters): Promise<TrackingOverviewResponse> {
//         const params = new URLSearchParams();
//         const date = filters?.date?.trim() || filters?.start_date?.trim();
//         if (date) params.set('date', date);
//         if (filters?.region_ids) params.set('region_ids', filters.region_ids);
//         if (filters?.city_ids) params.set('city_ids', filters.city_ids);
//         if (filters?.user_ids) params.set('user_ids', filters.user_ids);
//         if (filters?.report_to_ids) params.set('report_to_ids', filters.report_to_ids);
//         const q = params.toString();
//         const path = q ? `/bkpis_visit/tracking-overview?${q}` : '/bkpis_visit/tracking-overview';
//         return apiClient.get<TrackingOverviewResponse>(path);
//     }

//     async getUserTrackingVisits(userId: number, date: string): Promise<UserTrackingVisitsResponse> {
//         const params = new URLSearchParams({
//             user_id: String(userId),
//             date,
//         });
//         return apiClient.get<UserTrackingVisitsResponse>(`/bkpis_visit/tracking-overview/user-visits?${params.toString()}`);
//     }

//     async getTrackingStatusMap(filters?: TrackingOverviewFilters): Promise<TrackingStatusMapResponse> {
//         const params = new URLSearchParams();
//         if (filters?.region_ids) params.set('region_ids', filters.region_ids);
//         if (filters?.city_ids) params.set('city_ids', filters.city_ids);
//         if (filters?.user_ids) params.set('user_ids', filters.user_ids);
//         if (filters?.report_to_ids) params.set('report_to_ids', filters.report_to_ids);
//         const q = params.toString();
//         const path = q ? `/bkpis_visit/tracking-status-map?${q}` : '/bkpis_visit/tracking-status-map';
//         return apiClient.get<TrackingStatusMapResponse>(path);
//     }

//     async exportScoreCard(page: number = 1, limit: number = 10, filters?: any): Promise<Blob> {

//         const params = new URLSearchParams({
//             page: page.toString(),
//             limit: limit.toString()
//         });

//         if (filters) {
//             for (const [key, value] of Object.entries(filters)) {
//                 if (value === undefined || value === null || value === '') continue;

//                 let paramValue: string;

//                 if (typeof value === 'object') {
//                     paramValue = JSON.stringify(value); // safely handle objects/arrays
//                 } else if (
//                     typeof value === 'string' ||
//                     typeof value === 'number' ||
//                     typeof value === 'boolean'
//                 ) {
//                     paramValue = value.toString(); // handle primitives
//                 } else {
//                     continue; // skip unsupported types
//                 }

//                 params.set(key, paramValue);
//             }
//         }

//         const baseUrl = `/bkpis_visit/export-score-card-report`;
//         const queryString = params.toString();
//         const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;

//         return apiClient.getBlob(url, true, { showSuccessToast: true, successMessage: 'Exported Successfully' });
//     }

// }

// export const kPIVisitRepository = new KPIVisitRepository();




import { apiClient } from "../../../client";

export interface PaginatedResponse<T> {
    data: T[]
    total: number
    page: number
    limit: number
    totalPages: number
}

export interface KPIVisitFilters {
    search?: string;
    client_ids?: string;
    region_ids?: string;
    city_ids?: string;
    channel_ids?: string;
    chain_ids?: string;
    store_format_ids?: string;
    store_class_ids?: string;
    store_ids?: string;
    user_ids?: string;
    report_to_ids?: string;
    category_ids?: string;
    subcategory_ids?: string;
    start_date?: string;
    end_date?: string;
    /** Visit status: 0 = pending, 1 = in progress, 2 = completed */
    status?: string;
    shift_ids?: string;
    is_planned?: string;
    ref_ids?: string
}

/** Visit row for map: store + today's visits for current user */
export interface MapVisit {
    id: number;
    user_id: number;
    user_name: string;
    store_id: number;
    store_name: string;
    g_code: string | null;
    checkin_gps: string | null;
    shift_id: number;
    shift_name: string;
    status: number;
    from_date: string;
    to_date: string;
    client_id: number;
    checkin_time: string | null;
    checkin_image: string | null;
    checkout_time: string | null;
    checkout_image: string | null;
    dynamic_bucket_url: string;
    visit_type_name: string;
}

export interface TrackingLocationPoint {
    seq: number;
    time: string;
    store_id: number | null;
    store_name: string | null;
    lat: number;
    lng: number;
    distance_meters?: number | null;
    work_status?: string;
    indication?: string;
}

export interface TrackingUserRow {
    user_id: number;
    user_name: string;
    email: string | null;
    phone: string | null;
    region_name: string | null;
    city_name: string | null;
    location: string | null;
    lat: number | null;
    lng: number | null;
    last_track_at: string;
    last_seen: string;
    minutes_since_last_track: number;
    total_points: number;
    status: 'active' | 'idle' | 'offline';
    locations: TrackingLocationPoint[];
}

export interface TrackingOverviewFilters {
    date?: string;
    start_date?: string;
    region_ids?: string;
    city_ids?: string;
    user_ids?: string;
    report_to_ids?: string;
}

export type TrackingStatusMapStatus = 'In Store' | 'Idle / On Route' | 'Need Attention' | 'OK';

export interface TrackingStatusMapRow {
    user_id: number;
    user_name: string;
    username: string | null;
    region_id: number | null;
    region: string | null;
    city_id: number | null;
    city: string | null;
    store_id: number;
    store_name: string | null;
    location: string | null;
    lat: number | null;
    lng: number | null;
    last_tracking_time: string;
    distance_meters: number | null;
    status: TrackingStatusMapStatus;
    last_seen: string;
    work_status?: string;
    indication?: string;
}

export interface TrackingStatusMapResponse {
    summary: {
        total: number;
        in_store: number;
        idle_on_route: number;
        need_attention: number;
        ok: number;
    };
    users: TrackingStatusMapRow[];
}

export interface TrackingOverviewResponse {
    summary: {
        total: number;
        active: number;
        idle: number;
        offline: number;
    };
    users: TrackingUserRow[];
}

export interface TrackingVisitPin {
    id: number;
    sequence: number;
    tracking_time: string;
    tracked_at: string;
    location: string | null;
    lat: number;
    lng: number;
    store_id: number | null;
    store_name: string | null;
    distance_meters?: number | null;
    work_status?: string;
    indication?: string;
}

export interface UserTrackingVisitsResponse {
    user_id: number;
    user_name: string;
    date: string;
    visits: TrackingVisitPin[];
}

/** Date fields are sent as ISO 8601 strings (e.g. "2026-02-16T06:30:00Z") for correct backend parsing. */
export interface CreateKPIVisitRequest {

    project_code?: string;
    user_id: number;
    client_id: number;
    store_id: number;
    shift_id: number;
    is_planned: number;
    visit_type_id: number;
    status: number;
    from_date: string | Date;
    to_date: string | Date;
    category_ids?: number[];
    subcategory_ids?: number[];
    overtime_unplanned_visit?: number;
}

export interface UpdateKPIVisitRequest {
    id: number;
    project_code?: string;
    user_id: number;
    client_id: number;
    store_id: number;
    shift_id: number;
    is_planned: number;
    visit_type_id: number;
    status: number;
    from_date: string | Date;
    to_date: string | Date;
    category_ids?: number[];
    subcategory_ids?: number[];
    overtime_unplanned_visit?: number;
}


export interface KPIVisit {
    id: number;
    client_id: number;
    dynamic_bucket_url: string;
    tenant_id: number;
    client_name: string;
    project_code: string;
    user_id: number;
    user_name: string;
    user_display_name: string;
    store_id: number;
    store_name: string;
    depo?: string | null;
    shift_id: number;
    shift_name: string;
    is_planned: number;
    visit_type_id: number;
    status: number;
    from_date: Date;
    to_date: Date;
    report_to: number;
    report_to_name: string;
    region_name: string;
    city_name: string;
    channel_name?: string | null;
    chain_name?: string | null;
    store_format_name?: string | null;
    store_class_name?: string | null;
    visit_type_name: string;
    checkin_time: string;
    checkout_time: string;
    checkin_image: string;
    checkout_image: string;
    working_hours?: number;
    checkout_comment?: string;
    checkin_comment?: string;
    checkin_gps?: string;
    checkout_gps?: string;
    category_ids?: string | null;
    subcategory_ids?: string | null;
    category_names?: string[];
    subcategory_names?: string[];
    store_code?: string;
    g_code?: string | null;
    ref_id_1?: string
    overtime_unplanned_visit?: number;
    reason_text?: string;
    assign_by?: string;
}

/** Result of resetting a visit: 'hard' = permanently deleted (today), 'soft' = is_deleted = 1 (past date) */
export interface ResetKPIVisitResponse {
    success: boolean;
    mode: 'hard' | 'soft';
}

/** Attendance sheet row: each date maps to a single P/L/A string */
export interface AttendanceSheetRow {
    city_name: string;
    region_name: string;
    user_name: string;
    report_to_name: string;
    slots: Record<string, string>;
}

export interface AttendanceSheetByValueRow {
    id: number;
    city_name: string;
    region_name: string;
    user_name: string;
    userName: string;
    report_to_name: string;
    attendance_days: Record<string, string>;
}

export interface PerformanceOverviewAttendanceBreakdownItem {
    attendance: string;
    users: number;
}

export interface PerformanceOverviewAttendance {
    total: number;
    present: { count: number; percentage: number };
    absent: { count: number; percentage: number };
}

export interface PerformanceOverviewRegionRow {
    region: string;
    total: number;
    present: number;
    absent: number;
    jpc: number;
    productivityPct: number;
}

export interface PerformanceOverviewCityRow {
    city: string;
    total: number;
    present: number;
    absent: number;
    jpc: number;
    productivityPct: number;
}

export interface PerformanceOverviewReportToRow {
    region: string;
    city: string;
    reportTo: string;
    total: number;
    present: number;
    absent: number;
    jpc: number;
    productivityPct: number;
}

export interface PerformanceOverviewTrendPoint {
    label: string;
    value: number;
}

export interface PerformanceOverviewResponse {
    reportDate?: string;
    data: {
        attendanceBreakdown: PerformanceOverviewAttendanceBreakdownItem[];
        attendance: PerformanceOverviewAttendance;
        jpc: {
            planned: number;
            unplanned: number;
            completed: number;
            value: number;
            unplannedCompleted: number,
        };
        productivity: {
            planned: number;
            unplanned: number;
            completed: number;
            percentage: number;
        };
        summary: {
            totalUsers: number;
            plannedVisits: number;
            unplannedVisits: number;
            totalCompleted: number;
        };
    };
    byRegion?: PerformanceOverviewRegionRow[];
    byCity?: PerformanceOverviewCityRow[];
    byReportTo?: PerformanceOverviewReportToRow[];
    visitCheckinTrend?: PerformanceOverviewTrendPoint[];
    dayStartTrend?: PerformanceOverviewTrendPoint[];
    scorecardMetrics?: PerformanceOverviewScorecardMetrics;
    visitFunnel?: VisitOverviewSummary;
}

export interface PerformanceOverviewScorecardMetrics {

    totalWorkingMinutes: number;
    workingMinutesTarget: number;
    workingMinutesPct: number;
    totalTravelMinutes: number;
    avgWorkingMinutesPerUser: number;

    avgTravelMinutesPerUser: number;
    travelMinutesTarget: number;
    travelMinutesPct: number;
    totalTravelTime: number;

    avgStoreVisits: number;
    totalInStoreTime: number;
    inStoreTimePct: number;
}

export interface ScoreCardRow {
    date: string;
    region: string;
    city: string;
    user: string;
    reportTo: string;
    attendance: string;
    assigned: number;
    un_assigned: number;
    completed: number;
    productivity: number;
    efficiency: number;
}

export interface ScoreCardSummary {
    totalRows: number;
    /** Any check-in (OT + L) */
    present: number;
    onTime: number;
    late: number;
    absent: number;
    totalAssigned: number;
    totalCompleted: number;
    productivity: number;
    efficiency: number;
}

export interface ScoreCardResponse {
    data: ScoreCardRow[];
    total: number;
    page: number;
    limit: number;
    totalPages: number;
    summary: ScoreCardSummary;
}

export interface VisitOverviewSummary {
    total: number;
    pending: number;
    inprogress: number;
    completed: number;
    other: number;
}

export interface VisitOverviewFilters {
    start_date?: string;
    end_date?: string;
    region_ids?: string;
    city_ids?: string;
    user_ids?: string;
    report_to_ids?: string;
}

export interface VisitOverviewRegionStatus {
    region: string;
    pending: number;
    inprogress: number;
    completed: number;
    other: number;
    total: number;
}

export interface VisitOverviewCityStatus {
    city: string;
    pending: number;
    inprogress: number;
    completed: number;
    other: number;
    total: number;
}

export interface VisitOverviewRegionHeatmap {
    region: string;
    pending: number;
    inprogress: number;
    completed: number;
    other: number;
    total: number;
    completion_rate: number;
    center_lat: number | null;
    center_lng: number | null;
}

export interface VisitOverviewLocationBreakdownRow {
    region: string;
    city: string;
    reportTo: string;
    /** Report-to user type (e.g. SV, EL) for supervisor breakdown. */
    svBreakdown: string;
    pending: number;
    inprogress: number;
    completed: number;
    other: number;
    total: number;
    completionRate: number;
    /** Planned completed / planned visits (same definition as performance overview JPC). */
    jpc: number;
    productivityPct: number;
}

export interface VisitOverviewDetailsResponse {
    regionHeatmap: VisitOverviewRegionHeatmap[];
    statusByRegion: VisitOverviewRegionStatus[];
    statusByCity: VisitOverviewCityStatus[];
    locationBreakdown: VisitOverviewLocationBreakdownRow[];
}

export interface AttendanceOverviewAttendanceBreakdownItem {
    attendance: string;
    users: number;
}

export interface AttendanceOverviewSummary {
    total: number;
    present: number;
    absent: number;
    presentPct?: number;
    absentPct?: number;
}

export interface AttendanceOverviewRegionRow {
    region: string;
    total: number;
    present: number;
    absent: number;
}

export interface AttendanceOverviewCityRow {
    city: string;
    total: number;
    present: number;
    absent: number;
}

export interface AttendanceOverviewReportToRow {
    region: string;
    city: string;
    reportTo: string;
    total: number;
    present: number;
    absent: number;
    jpc?: number;
    productivityPct?: number;
}

export interface AttendanceOverviewResponse {
    reportDate?: string;
    attendanceBreakdown?: AttendanceOverviewAttendanceBreakdownItem[];
    summary: AttendanceOverviewSummary;
    byRegion: AttendanceOverviewRegionRow[];
    byCity: AttendanceOverviewCityRow[];
    byReportTo: AttendanceOverviewReportToRow[];
}

class KPIVisitRepository {


    async findAll(page: number = 1, limit: number = 10, filters?: KPIVisitFilters): Promise<PaginatedResponse<KPIVisit>> {
        const params = new URLSearchParams({
            page: page.toString(),
            limit: limit.toString(),
        });

        if (filters) {
            for (const [key, value] of Object.entries(filters)) {
                if (value == null || value === '') continue;
                params.append(key, String(value));
            }
        }

        return apiClient.get<PaginatedResponse<KPIVisit>>(`/bkpis_visit?${params.toString()}`);
    }

    async getAttendance(year: number, month: number): Promise<{ data: AttendanceSheetRow[] }> {
        const params = new URLSearchParams({ year: String(year), month: String(month) });
        return apiClient.get<{ data: AttendanceSheetRow[] }>(`/bkpis_visit/attendance?${params.toString()}`);
    }

    // async getAttendanceByValue(year: number, month: number): Promise<{ data: AttendanceSheetByValueRow[] }> {
    //     const params = new URLSearchParams({ year: String(year), month: String(month) });
    //     return apiClient.get<{ data: AttendanceSheetByValueRow[] }>(`/bkpis_visit/attendancebyValue?${params.toString()}`);
    // }

    async getAttendanceByValue(params: { start_date: string, end_date: string }): Promise<{ data: AttendanceSheetByValueRow[] }> {
        const query = new URLSearchParams(params).toString()
        return apiClient.get<{ data: AttendanceSheetByValueRow[] }>(`/bkpis_visit/attendancebyValue?${query}`);
    }

    async getPerformanceOverview(): Promise<PerformanceOverviewResponse> {
        return apiClient.get<PerformanceOverviewResponse>('/performance-overview');
    }

    /** Get visits for map. Omit storeId to get all visits for the date (show users on map). */
    async getVisitsForMap(storeId?: number | null, date?: string): Promise<{ data: MapVisit[] }> {
        const params = new URLSearchParams();
        if (storeId != null) params.set('store_id', String(storeId));
        if (date) params.set('date', date);
        const q = params.toString();
        const path = q ? `/bkpis_visit/map?${q}` : '/bkpis_visit/map';
        return apiClient.get<{ data: MapVisit[] }>(path);
    }

    async create(data: CreateKPIVisitRequest): Promise<KPIVisit> {
        return apiClient.post<KPIVisit>('/bkpis_visit', data)
    }


    async update(id: number, data: UpdateKPIVisitRequest): Promise<KPIVisit> {
        return apiClient.put<KPIVisit>(`/bkpis_visit/${id}`, data)
    }

    async delete(id: number): Promise<{ message: string }> {
        return apiClient.delete<{ message: string }>(`/bkpis_visit/${id}`)
    }

    /**
     * Reset a visit.
     * Today's visit  -> hard delete (visit + all reporting rows).
     * Past visit     -> soft delete (is_deleted = 1 on visit + reporting rows).
     * Decided on the server.
     */
    async reset(id: number): Promise<ResetKPIVisitResponse> {
        return apiClient.post<ResetKPIVisitResponse>(`/bkpis_visit/${id}/reset`, undefined,
            true, {
            successMessage: 'Record reset successfully.',
        },
        )
    }

    async exportTemplate(filters?: KPIVisitFilters): Promise<Blob> {
        const params = new URLSearchParams()

        if (filters) {
            if (filters.search) params.append('search', filters.search);
        }

        const API_BASE_URL = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:5000'
        const baseUrl = `${API_BASE_URL}/bkpis_visit/export/template`;
        const queryString = params.toString();
        const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;

        return apiClient.getBlob(url, true, { showSuccessToast: true, successMessage: 'Exported Successfully' })
    }

    async importFromExcel(file: File): Promise<{
        success: boolean;
        message: string;
        data: {
            success: boolean;
            total: number;
            created: number;
            updated: number;
            errors: Array<{ row: number; message: string }>;
        };
    }> {
        const formData = new FormData()
        formData.append('file', file)
        return apiClient.post('/bkpis_visit/import/excel', formData)
    }

    async importTable(file: File, tableName: string, sheetName?: string): Promise<{
        success: boolean;
        message: string;
        data: {
            success: boolean;
            total: number;
            created: number;
            updated: number;
            errors: Array<{ row: number; message: string }>;
        };
    }> {
        const formData = new FormData()
        formData.append('file', file)
        formData.append('tableName', tableName)
        if (sheetName) formData.append('sheetName', sheetName)
        return apiClient.post('/bkpis_visit/table/import', formData)
    }

    async exportTableTemplate(tableName: string): Promise<Blob> {
        return apiClient.getBlob(`/bkpis_visit/table/${tableName}/export/template`)
    }

    async exportAttendance(params: { year: number; month: number }): Promise<Blob> {
        const query = new URLSearchParams({
            year: String(params.year),
            month: String(params.month),
        }).toString()

        const url = `/bkpis_visit/attendance/export?${query}`

        const response = await apiClient.getBlob(url, true, { showSuccessToast: true, successMessage: 'Exported Successfully' })

        return response
    }

    async findAllTableRecords(tableName: string): Promise<Array<{ id: number; name: string; from: string; to: string; status: number }>> {
        return apiClient.get<{ data: Array<{ id: number; name: string; from: string; to: string; status: number }> }>(`/bkpis_visit/table/${tableName}`)
            .then(response => response.data);
    }

    async exportToExcel(page: number = 1, limit: number = 25, filters?: any): Promise<Blob> {

        const params = new URLSearchParams({
            page: page.toString(),
            limit: limit.toString()
        });

        if (filters) {
            for (const [key, value] of Object.entries(filters)) {
                if (value === undefined || value === null || value === '') continue;

                let paramValue: string;

                if (typeof value === 'object') {
                    paramValue = JSON.stringify(value); // safely handle objects/arrays
                } else if (
                    typeof value === 'string' ||
                    typeof value === 'number' ||
                    typeof value === 'boolean'
                ) {
                    paramValue = value.toString(); // handle primitives
                } else {
                    continue; // skip unsupported types
                }

                params.set(key, paramValue);
            }
        }

        const baseUrl = `/bkpis_visit/visit-history/export`;
        const queryString = params.toString();
        const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;

        return apiClient.getBlob(url, true, { showSuccessToast: true, successMessage: 'Exported Successfully' });
    }

    async getScoreCard(
        page: number = 1,
        limit: number = 10,
        filters?: { date?: string; start_date?: string; end_date?: string; region_ids?: string; city_ids?: string; user_ids?: string },
    ): Promise<ScoreCardResponse> {
        const params = new URLSearchParams({
            page: page.toString(),
            limit: limit.toString(),
        });
        if (filters?.date) params.set('date', filters.date);
        if (filters?.start_date) params.set('start_date', filters.start_date);
        if (filters?.end_date) params.set('end_date', filters.end_date);
        if (filters?.region_ids) params.set('region_ids', filters.region_ids);
        if (filters?.city_ids) params.set('city_ids', filters.city_ids);
        if (filters?.user_ids) params.set('user_ids', filters.user_ids);

        return apiClient.get<ScoreCardResponse>(`/bkpis_visit/score-card?${params.toString()}`);
    }

    async getVisitOverviewSummary(filters?: VisitOverviewFilters): Promise<VisitOverviewSummary> {
        const params = new URLSearchParams();
        if (filters?.start_date) params.set('start_date', filters.start_date);
        if (filters?.end_date) params.set('end_date', filters.end_date);
        if (filters?.region_ids) params.set('region_ids', filters.region_ids);
        if (filters?.city_ids) params.set('city_ids', filters.city_ids);
        if (filters?.user_ids) params.set('user_ids', filters.user_ids);
        if (filters?.report_to_ids) params.set('report_to_ids', filters.report_to_ids);

        const q = params.toString();
        const path = q ? `/bkpis_visit/visit-overview/summary?${q}` : '/bkpis_visit/visit-overview/summary';
        return apiClient.get<VisitOverviewSummary>(path);
    }

    async getVisitOverviewDetails(filters?: VisitOverviewFilters): Promise<VisitOverviewDetailsResponse> {
        const params = new URLSearchParams();
        if (filters?.start_date) params.set('start_date', filters.start_date);
        if (filters?.end_date) params.set('end_date', filters.end_date);
        if (filters?.region_ids) params.set('region_ids', filters.region_ids);
        if (filters?.city_ids) params.set('city_ids', filters.city_ids);
        if (filters?.user_ids) params.set('user_ids', filters.user_ids);
        if (filters?.report_to_ids) params.set('report_to_ids', filters.report_to_ids);

        const q = params.toString();
        const path = q ? `/bkpis_visit/visit-overview/details?${q}` : '/bkpis_visit/visit-overview/details';
        return apiClient.get<VisitOverviewDetailsResponse>(path);
    }

    async getAttendanceOverview(filters?: VisitOverviewFilters): Promise<AttendanceOverviewResponse> {
        const params = new URLSearchParams();
        if (filters?.start_date) params.set('start_date', filters.start_date);
        if (filters?.end_date) params.set('end_date', filters.end_date);
        if (filters?.region_ids) params.set('region_ids', filters.region_ids);
        if (filters?.city_ids) params.set('city_ids', filters.city_ids);
        if (filters?.user_ids) params.set('user_ids', filters.user_ids);
        const q = params.toString();
        const path = q ? `/attendance-overview?${q}` : '/attendance-overview';
        return apiClient.get<AttendanceOverviewResponse>(path);
    }

    async getTrackingOverview(filters?: TrackingOverviewFilters): Promise<TrackingOverviewResponse> {
        const params = new URLSearchParams();
        const date = filters?.date?.trim() || filters?.start_date?.trim();
        if (date) params.set('date', date);
        if (filters?.region_ids) params.set('region_ids', filters.region_ids);
        if (filters?.city_ids) params.set('city_ids', filters.city_ids);
        if (filters?.user_ids) params.set('user_ids', filters.user_ids);
        if (filters?.report_to_ids) params.set('report_to_ids', filters.report_to_ids);
        const q = params.toString();
        const path = q ? `/bkpis_visit/tracking-overview?${q}` : '/bkpis_visit/tracking-overview';
        return apiClient.get<TrackingOverviewResponse>(path);
    }

    async getUserTrackingVisits(userId: number, date: string): Promise<UserTrackingVisitsResponse> {
        const params = new URLSearchParams({
            user_id: String(userId),
            date,
        });
        return apiClient.get<UserTrackingVisitsResponse>(`/bkpis_visit/tracking-overview/user-visits?${params.toString()}`);
    }

    async getTrackingStatusMap(filters?: TrackingOverviewFilters): Promise<TrackingStatusMapResponse> {
        const params = new URLSearchParams();
        if (filters?.region_ids) params.set('region_ids', filters.region_ids);
        if (filters?.city_ids) params.set('city_ids', filters.city_ids);
        if (filters?.user_ids) params.set('user_ids', filters.user_ids);
        if (filters?.report_to_ids) params.set('report_to_ids', filters.report_to_ids);
        const q = params.toString();
        const path = q ? `/bkpis_visit/tracking-status-map?${q}` : '/bkpis_visit/tracking-status-map';
        return apiClient.get<TrackingStatusMapResponse>(path);
    }

    async exportScoreCard(page: number = 1, limit: number = 10, filters?: any): Promise<Blob> {

        const params = new URLSearchParams({
            page: page.toString(),
            limit: limit.toString()
        });

        if (filters) {
            for (const [key, value] of Object.entries(filters)) {
                if (value === undefined || value === null || value === '') continue;

                let paramValue: string;

                if (typeof value === 'object') {
                    paramValue = JSON.stringify(value); // safely handle objects/arrays
                } else if (
                    typeof value === 'string' ||
                    typeof value === 'number' ||
                    typeof value === 'boolean'
                ) {
                    paramValue = value.toString(); // handle primitives
                } else {
                    continue; // skip unsupported types
                }

                params.set(key, paramValue);
            }
        }

        const baseUrl = `/bkpis_visit/export-score-card-report`;
        const queryString = params.toString();
        const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;

        return apiClient.getBlob(url, true, { showSuccessToast: true, successMessage: 'Exported Successfully' });
    }

}

export const kPIVisitRepository = new KPIVisitRepository();